import './spinner.css';

const Spinner = () => {
  return (
      <div className='spinner'>
		  <div className='loadingio-spinner-blocks-0eujyh0le72f'>
		  <div className='ldio-r4zsbsoo1xj'>
			<div className='spinner__item-1'></div>
			<div className='spinner__item-2'></div>
			<div className='spinner__item-3'></div>
			<div className='spinner__item-4'></div>
		  </div>
		  </div>
	  </div>
  );
};

export default Spinner;